import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await register(email, password, name);
    setBusy(false);
    if (res.ok) {
      toast.success("Account created — let's log your first match.");
      navigate("/profile");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-15 bg-cover bg-center pointer-events-none"
           style={{ backgroundImage: `url('https://images.unsplash.com/photo-1599982946086-eb42d9e14eb8?crop=entropy&cs=srgb&fm=jpg&q=85')` }} />
      <Link to="/" className="absolute top-8 left-1/2 -translate-x-1/2 flex items-center gap-3 group">
        <div className="w-10 h-10 rounded bg-[#FF3B30] flex items-center justify-center text-white font-black text-xl shadow-[0_0_15px_rgba(255,59,48,0.5)] group-hover:scale-105 transition-transform">CP</div>
        <h1 className="text-2xl font-black uppercase tracking-wider text-white">CRICKETPULSE</h1>
      </Link>
      <div className="relative z-10 w-full max-w-md bg-[#141414] border border-[#262626] rounded-2xl p-8 shadow-2xl space-y-6">
        <div className="space-y-2">
          <div className="inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-[#FF3B30] bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded px-2.5 py-1">
            <UserPlus className="w-3 h-3" /> Player Registration
          </div>
          <h2 className="text-3xl font-black uppercase text-white">Join CricketPulse</h2>
          <p className="text-sm text-[#A3A3A3]">Track batting, bowling and get AI coach reports.</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-mono text-[#A3A3A3] uppercase mb-1">Full Name</label>
            <input
              data-testid="register-name-input"
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-[#262626] rounded px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF3B30]"
              placeholder="Alex Vance"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-[#A3A3A3] uppercase mb-1">Email</label>
            <input
              data-testid="register-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-[#262626] rounded px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF3B30]"
              placeholder="alex@cricket.com"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-[#A3A3A3] uppercase mb-1">Password</label>
            <input
              data-testid="register-password-input"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#1A1A1A] border border-[#262626] rounded px-3 py-2.5 text-sm text-white focus:outline-none focus:border-[#FF3B30]"
              placeholder="At least 6 characters"
            />
          </div>

          {error && (
            <div data-testid="register-error" className="bg-[#FF3B30]/10 border border-[#FF3B30]/40 text-[#FF3B30] text-xs rounded px-3 py-2">
              {error}
            </div>
          )}

          <button
            data-testid="register-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full bg-[#FF3B30] hover:bg-[#E03229] disabled:opacity-50 text-white font-bold py-2.5 rounded text-sm transition-all shadow-lg"
          >
            {busy ? "Creating..." : "CREATE ACCOUNT"}
          </button>
        </form>

        <div className="text-center text-xs text-[#A3A3A3]">
          Already have an account?{" "}
          <Link data-testid="link-to-login" to="/login" className="text-[#FF3B30] font-bold hover:underline">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
